import React, { useEffect, useRef } from "react";

/**
 * Renders a hidden form and auto-submits it to Redsys to redirect the user.
 * @param {{ action: string, fields: { Ds_SignatureVersion: string, Ds_MerchantParameters: string, Ds_Signature: string } }} props
 */
export default function RedsysRedirectForm({ action, fields }) {
  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit();
    }
  }, []);

  return (
    <form
      ref={formRef}
      action={action}
      method="POST"
      acceptCharset="UTF-8"
      data-testid="redsys-redirect-form"
      style={{ display: "none" }}
    >
      {Object.entries(fields).map(([name, value]) => (
        <input key={name} type="hidden" name={name} value={value} />
      ))}
    </form>
  );
}
